import { ChartDataParams } from '../StatsBarChart';

export const getTotalAmount = (data: ChartDataParams[]): number => {
  return data.reduce(
    (previousValue, currentValue) => previousValue + currentValue.amount,
    0,
  );
};
